/**
 * PWA install + notifications helpers
 */

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((cb) => cb({ canInstall: true }));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    localStorage.setItem("fidelis_pwa_installed", "1");
    listeners.forEach((cb) => cb({ canInstall: false, installed: true }));
  });
}

export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    localStorage.getItem("fidelis_pwa_installed") === "1"
  );
};

export const isIos = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPhone|iPad|iPod/i.test(ua) && !window.MSStream;
};

export const isAndroid = () => {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
};

export const canPromptInstall = () => !!deferredPrompt;

export const promptInstall = async () => {
  if (!deferredPrompt) return { outcome: "unavailable" };
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  listeners.forEach((cb) => cb({ canInstall: false }));
  return choice;
};

export const onInstallStateChange = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

/** Notifications */
export const notificationSupported = () =>
  typeof window !== "undefined" && "Notification" in window && "serviceWorker" in navigator;

export const requestNotificationPermission = async () => {
  if (!notificationSupported()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch {
    return "denied";
  }
};

export const showLocalNotification = async (title, body) => {
  if (!notificationSupported() || Notification.permission !== "granted") return;
  try {
    const reg = await navigator.serviceWorker.ready;
    reg.showNotification(title, { body, icon: "/icon-192.png", badge: "/icon-192.png" });
  } catch {
    try { new Notification(title, { body, icon: "/icon-192.png" }); } catch {}
  }
};
